export const SESSION_STORAGE = {
    SOLUTION_REFER: 'jdy.solution_refer', // 方案中心入口
    DELETED_ACCOUNT_TOKEN: 'jdy.deleted_account_token', // 已注销企业零时登录凭证
    APP_USAGE_DETAIL: 'jdy.app_usage_detail', // 应用用量详情
    API_DEBUG_NO_TIP: 'jdy.api_debug_no_tip', // 调试台 - 提示
    /** store数据源信息缓存 */
    OPEN_DATA_SOURCE_PRESET: 'jdy.open_data_source_preset',
    /** 插件跳转后自动定位 */
    OPEN_PLUGIN_NAV: 'jdy.open_plugin_nav',
    /** 跳转插件编辑页后定位到指定函数 */
    OPEN_PLUGIN_EDIT_FN: 'jdy.open_plugin_edit_fn'
};
